export const LeftIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 12L6.5 8L10.5 4"
        stroke="#150823"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};
